import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const TalkingPointsToParagraph = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14914)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#F4F4F4"
          />
          <rect
            x="81.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M138.937 30.2857L82.2857 108.457C82.2857 108.457 82.6836 110.595 83.3919 111.366C84.1002 112.138 85.0608 112.571 86.0625 112.571H138.937C139.939 112.571 140.9 112.138 141.608 111.366C142.316 110.595 142.714 109.548 142.714 108.457V34.4C142.714 33.3088 142.316 32.2623 141.608 31.4908C140.9 30.7192 138.937 30.2857 138.937 30.2857Z"
            fill="#E3E3E3"
          />
          <path
            d="M95.1429 48.2856H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1429 55.9999H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1429 63.7142H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1429 71.4285H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1429 79.1428H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1429 86.8571H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1429 94.5714H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="81.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M164.404 74.6141L161.998 77.0195L153.981 69.0016L156.386 66.5962C157.455 65.5613 158.888 64.9881 160.376 65.0002C161.864 65.0123 163.287 65.6087 164.339 66.6608C165.391 67.7129 165.988 69.1364 166 70.6242C166.012 72.1121 165.439 73.5451 164.404 74.6141Z"
            fill="#FF808C"
          />
          <path
            d="M145.225 93.7928L134 97L137.207 85.7749L145.225 93.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M153.981 69.0048L137.207 85.7783L145.225 93.7962L161.998 77.0227L153.981 69.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M164.404 74.6141L161.998 77.0195L153.981 69.0016L156.386 66.5962C157.455 65.5613 158.888 64.9881 160.376 65.0002C161.864 65.0123 163.287 65.6087 164.339 66.6608C165.391 67.7129 165.988 69.1364 166 70.6242C166.012 72.1121 165.439 73.5451 164.404 74.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M145.225 93.7928L134 97L137.207 85.7749L145.225 93.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.981 69.0048L137.207 85.7783L145.225 93.7962L161.998 77.0227L153.981 69.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14914">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
